import { useEffect, useState } from "react";
import TopPageTitle from "../../../components/TopPageTitle/TopPageTitle";
import { PagesWrapper } from "../../../styles/components/PagesWrapper.styled";
import * as styled from "./Vocabulary.styled";
import { useDispatch } from "react-redux";
import { fetchAuthMe } from "../../../redux/slices/auth";
import Loader from "../../../components/Loader/Loader";
import axios from "../../../axios";
import AddWordForm from "../../../components/AddWordForm/AddWordForm";
import VocabularyTable from "../../../components/VocabularyTable/VocabularyTable";
import StudentList from "../../../components/StudentList/StudentList";
function Vocabulary() {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [student, setStudent] = useState(null);
  const [vocabulary, setVocabulary] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await dispatch(fetchAuthMe());
      setData(response.payload);
    };

    fetchData();
  }, [dispatch]);

  useEffect(() => {
    // Список учнів потрібен лише вчителю
    if (!data || data.userType !== 'teacher') return;
    const getStudents = async () => {
      const response = await axios.get(`students-by-teacher/${data._id}`);
      setStudent(response.data);
    };

    getStudents();
  }, [data]);

  useEffect(() => {
      if(!data) return
    if (data.userType === 'student' || selectedStudent) {
      axios
        .get(`${data.userType === 'student' ? data._id : selectedStudent._id}/vocabulary`)
        .then((res) => setVocabulary(res.data));
    }
  }, [selectedStudent, data]);

  const addWord = async ({ word, translation }) => {
    const res = await axios.post(`${data.userType === 'student' ? data._id : selectedStudent._id}/vocabulary`, {
      word,
      translation,
      addedBy: data._id,
      teacherName: data.name,
      teacherId: data._id,
    });
    setVocabulary(res.data.vocabulary);
  };

  const deleteWord = async (wordId) => {
    await axios.delete(`/vocabulary/${wordId}`);
    setVocabulary((prev) => prev.filter((w) => w._id !== wordId));
  };

  const toggleLearned = async (wordId) => {
    const word = vocabulary.find((w) => w._id === wordId);
    const updated = { isLearned: !word.isLearned };
    await axios.put(`/vocabulary/${wordId}`, updated);
    setVocabulary((prev) =>
      prev.map((w) => (w._id === wordId ? { ...w, ...updated } : w))
    );
  };
  
  if (!data || (data.userType === 'teacher' ? !student : false)) {
      return <Loader />;
   }
   console.log(data)
   console.log(student)
  
  return (
    <PagesWrapper>
      <TopPageTitle value={"Словник"} />
     {data.userType === 'teacher' && <StudentList students={student} selectedStudent={selectedStudent} onSelectStudent={setSelectedStudent} />}
      {(data.userType === 'student' || selectedStudent) && (
        <>
          <AddWordForm onAdd={addWord} />

          <VocabularyTable
            words={vocabulary}
            onDelete={deleteWord}
            onToggleLearned={toggleLearned}
          />
        </>
      )}
    </PagesWrapper>
  );
}

export default Vocabulary;
